import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=60f7c85e&scoped=true"
import script from "./ReportsList.ts?vue&type=script&lang=ts&external"
export * from "./ReportsList.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=60f7c85e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7c85e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f7c85e')) {
      api.createRecord('60f7c85e', component.options)
    } else {
      api.reload('60f7c85e', component.options)
    }
    module.hot.accept("./ReportsList.vue?vue&type=template&id=60f7c85e&scoped=true", function () {
      api.rerender('60f7c85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/historical/ReportsList/ReportsList.vue"
export default component.exports